import { createAction, props } from '@ngrx/store';

import {
    IEjecucionPalanca,
    IResulApi,
    IResult,
    IResultEjecucion,
    IResultSaveInsue,
    IUploadPictures,
} from '../../private/shared/models/task-ejecucion';

/**
 * Obtiene las palancas comerciales, si tiene tarea o no
 */
export const getEjecucionTarea = createAction(
    '[GetEjecucionTarea] Get Ejecucion Tarea',
);

export const successEjecucionTarea = createAction(
    '[GetEjecucionTarea] Get Ejecucion Tarea Success',
    props<IResult>()
);

export const setTaskCompleted = createAction(
    '[GetEjecucionTarea] Set Task Completed',
    props<{ tasks: IEjecucionPalanca[] }>()
);

export const errorEjecucionTarea = createAction(
    '[GetEjecucionTarea] Get Ejecucion Tarea Error',
    props<{ payload: Error }>()
);

export const ClearGetEjecucionTarea = createAction(
    '[GetEjecucionTarea] Clear Get Ejecucion Tarea',
);

/**
 * Envia la tarea de ejecucion
 */
export const sendEjecucionTarea = createAction(
    '[SendEjecucionTarea] Send Ejecucion Tarea',
    props<IUploadPictures>()
);

export const successSendEjecucionTarea = createAction(
    '[SendEjecucionTarea] Send Ejecucion Tarea Success',
    props<IResulApi>()
);

export const errorSendEjecucionTarea = createAction(
    '[SendEjecucionTarea] Send Ejecucion Tarea Error',
    props<{ payload: Error }>()
);

export const ClearEjecucionTarea = createAction(
    '[SendEjecucionTarea] Clear Ejecucion Tarea',
);

/**
 * Envia comentarios de ejecucion
 */
export const sendEjecucionIncidencia = createAction(
    '[SendEjecucionIncidencia] Send Ejecucion Incidencia',
    props<{ ID_EjecucionIncidencias: number; Incidencia: string; }>()
);

export const successSendEjecucionIncidencia = createAction(
    '[SendEjecucionIncidencia] Send Ejecucion Incidencia Success',
    props<IResultSaveInsue>()
);

export const errorSendEjecucionIncidencia = createAction(
    '[SendEjecucionIncidencia] Send Ejecucion Incidencia Error',
    props<{ payload: Error }>()
);

export const ClearEjecucionIncidencia = createAction(
    '[SendEjecucionIncidencia] Clear Ejecucion Incidencia',
);

/**
 * Obtiene los resultados de ejecucion
 */
export const getResultEjecucion = createAction(
    '[GetResultEjecucion] Get Ejecucion Result',
    props<{ idPalancaComercial: number; cantidadResultados?: number; pagina?: number }>()
);

export const successGetResultEjecucion = createAction(
    '[GetResultEjecucion] Get Ejecucion Result Success',
    props<IResultEjecucion>()
);

export const errorGetResultEjecucion = createAction(
    '[GetResultEjecucion] Get Ejecucion Result Error',
    props<{ payload: Error }>()
);

export const ClearResultEjecucion = createAction(
    '[GetResultEjecucion] Clear Ejecucion Result',
);
